import { render, staticRenderFns } from "./Feature.vue?vue&type=template&id=011dd84c&scoped=true&"
import script from "./Feature.vue?vue&type=script&lang=js&"
export * from "./Feature.vue?vue&type=script&lang=js&"
import style0 from "./Feature.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Feature.vue?vue&type=style&index=1&id=011dd84c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011dd84c",
  null
  
)

export default component.exports